import { type WizardStep } from 'portal-commons';
import {
  StepRegisterFormData,
  StepCspDetailsFormData,
  StepContactDetailsFormData,
} from './types';

export const WizardSteps: WizardStep[] = [
  { key: 'register', label: 'Register' },
  { key: 'details', label: 'CSP Details' },
  { key: 'contact', label: 'Contact Details' },
  { key: 'terms', label: 'Terms & Conditions' },
];

export const EXCLUDED_COUNTRIES = ['US', 'CU', 'IR', 'KP', 'SY'];

export const ENTITY_TYPE_OPTIONS = [
  {
    label: 'PUBLIC_PROFIT',
    value: 'PUBLIC_PROFIT',
  },
  {
    label: 'PRIVATE_PROFIT',
    value: 'PRIVATE_PROFIT',
  },
  {
    label: 'NON_PROFIT',
    value: 'NON_PROFIT',
  },
];

export const DefaultRegisterFormData: StepRegisterFormData = {
  market: 'US',
  questionnairePrimaryCnpName: '',
  questionnaireRelationshipLength: '',
  questionnaireSecondaryCnpName: '',
  questionnaireRelationshipLengthSecondaryCNP: '',
};
export const DefaultDetailsFormData: StepCspDetailsFormData = {
  companyName: '',
  displayName: '',
  country: '',
  entityType: '',
  ein: '',
  street: '',
  city: '',
  state: '',
  postalCode: '',
  website: '',
  stockSymbol: '',
  stockExchange: '',
  questionnaireSnowshoeAnswer: '',
  questionnaireATOAnswer: '',
};
export const DefaultContactFormData: StepContactDetailsFormData = {
  phone: '',
  email: [{ email: '' }],
  financeEmail: [{ email: '' }],
  escalateEmail: [{ email: '' }],
  techEmail: [{ email: '' }],
};
